module.exports = __webpack_public_path__ + "img/arrow-left.1118c8dc.svg";